// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireInformationActions = require('actions/hireInformation');
const { updateConsents } = require('actions/gdprConsents');
const hireContactDataActions = require('actions/hireContactData');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
  getCardStandard,
  getDebitCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const ccActionTypes = require('constants/contactCenter/actionTypes');
const { DEBIT_AT_HOME_ABROAD_SUBTYPE, DEBIT_CARD_TYPE, THIRD_STEP } = require('constants/index');
const { AT_HOME_ABROAD_CARD_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_RESET,
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

function setAgreementCheckbox(evt) {
  return {
    type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked: evt.target.checked,
    },
  };
}

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}
function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid) {
  return {
    type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
    },
  };
}

const validateSecondStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  dispatch(validate(step, externalComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardAtHomeAbroad.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const validateStep = step => (dispatch, getState) => {
  if (step === 2) {
    //SECOND_STEP
    dispatch(hireCardImageSelectorActions.validateStep());
    dispatch(validateSecondStep(step));
  } else if (step === 4) {
    //FOURTH STEP
    dispatch(validateThirdStep(step));
  } else if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    const immCards = getState().cards;
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');

    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    dispatch(validateLoading(true));
    return APIPost({
      dispatch,
      endpoint: 'validateCardHire',
      params: {
        query: { cards: cardObj },
      },
    })
      .then(() => {
        dispatch(validateLoading(false));
    dispatch(validate(step, false));
      })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            dispatch(validate(step, true));
            dispatch(validateLoading(false));
          } else {
            dispatch(hireCardAtHomeAbroadFailure(''));
            dispatch(validateLoading(false));
          }
        }
      });
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }
  return dispatch(getStep(step));
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const getPrecontractualInfoLinkRequest = () => ({
  type: ccActionTypes.HIRE_CARD_AT_HOME_ABROAD_PRECONTRACTUAL_LINK_REQUEST,
});

const getPrecontractualInfoLinkSuccess = response => ({
  type: ccActionTypes.HIRE_CARD_AT_HOME_ABROAD_PRECONTRACTUAL_LINK_SUCCESS,
  payload: {
    response,
  },
});

const getPrecontractualInfoLinkFailure = error => ({
  type: ccActionTypes.HIRE_CARD_AT_HOME_ABROAD_PRECONTRACTUAL_LINK_FAILURE,
  payload: {
    error,
  },
});

const getPrecontractualInfoLink = params => dispatch => {
  const requestData = {
    query: {
      referencia: {
        estandar: params.estandar,
        subtipo: params.subtipo,
        tipo: params.tipo,
      },
    },
  };

  dispatch(getPrecontractualInfoLinkRequest());

  return APIPost(dispatch, apiURLBuilder.getURL('requestPDFPreviewPreContract'), requestData)
    .then(response => dispatch(getPrecontractualInfoLinkSuccess(response)))
    .catch(error => dispatch(getPrecontractualInfoLinkFailure(error)));
};

const hireCardAtHomeAbroadRequest = () => ({
  type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_REQUEST,
});

const hireCardAtHomeAbroadSuccess = response => ({
  type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_SUCCESS,
  payload: {
    response,
  },
});

const hireCardAtHomeAbroadFailure = errorMsg => ({
  type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_FAILURE,
  payload: {
    errorMsg,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_AT_HOME_ABROAD_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardAtHomeAbroad = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    query: data,
    header: {
      version: 2,
    },
  };

  dispatch(hireCardAtHomeAbroadRequest());

  return APIPost({
    dispatch,
    endpoint: 'hireDebitCardAtHomeAbroad',
    params: requestData,
  })
    .then(response => {
      const status = getDebitCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardAtHomeAbroadFailure(status.errorMsg));
      } else {
        dispatch(hireCardAtHomeAbroadSuccess(response));
        dispatch(setTermsAndCondsInfo(AT_HOME_ABROAD_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
      }
    })
    .catch(response => {
      const status = getDebitCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardAtHomeAbroadFailure(status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardAtHomeAbroadFailure(''));
      } else {
        throw response;
      }
    });
};

const hireCardAtHomeAbroad = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardAtHomeAbroad.getIn(['steps', THIRD_STEP, 'accountId']);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));

    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    let addressDetails = null;
    let numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails,
      deliverToProvidedDetails: true,
      cardDetails: {
        cuentaCargo: `00730100${immAccount.get('product')}${immAccount.get('contractNumber')}`,
        tarjetaRef: {
          standard: cardDesignKey,
        },
        //TODO: To be replace with actual data once get approved
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
      },
      numDomicilio,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: DEBIT_AT_HOME_ABROAD_SUBTYPE,
        type: DEBIT_CARD_TYPE,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardAtHomeAbroad(dispatch, data, termsAndsCondsHiringData))
      .catch(response => {
        if (!!response.error) {
          setCardAtHomeAbroad(dispatch, data, termsAndsCondsHiringData);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  getPrecontractualInfoLink,
  hireCardAtHomeAbroad,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validateStep,
};
